import * as React from 'react';
import { useState } from 'react';
import { FormattedHTMLMessage, InjectedIntl, intlShape } from 'react-intl';
import './Tooltip.scss';

interface TooltipProps {
    fieldId: string;
    intl: InjectedIntl;
    tooltipText: string;
}

const TooltipComponent : React.FC<TooltipProps> = ({ fieldId, intl, tooltipText }) => {
    const [tooltipIsOpen, setTooltipIsOpen] = useState(false);

    const showTooltip = () => setTooltipIsOpen(true);
    const hideTooltip = () => setTooltipIsOpen(false);

    const handleOnClick = (tooltipIsOpen: boolean) => {
        if (tooltipIsOpen) {
            hideTooltip();
        } else {
            showTooltip();
        }
    }

    return(
        <div
            className="sid-form-tooltip"
            onMouseEnter={showTooltip}
            onMouseLeave={hideTooltip}
        >
            <button
                className="sid-form-tooltip-link"
                onFocus={showTooltip}
                onBlur={hideTooltip}
                onClick={() => handleOnClick(tooltipIsOpen)}
                aria-labelledby={`${fieldId}-tooltip`}
                aria-describedby={`${fieldId}-tooltip`}
                aria-label={intl.formatMessage({id: `${fieldId}.tooltipText`})}
            >
                <i className="fa fa-question-circle-o"></i>
            </button>
            {
                tooltipIsOpen ?
                    <div className="sid-form-tooltip__container" id={`${fieldId}-tooltip`} role="tooltip">
                        <div className="sid-form-tooltip__caret" />
                        <div className="sid-form-tooltip__tooltip">

                                <div className="sid-form-tooltip__text sid-form-tooltip__content">
                                    <div className="sid-tooltip-top">
                                        {tooltipText}
                                    </div>
                                </div>
                        </div>
                    </div>
                    :
                    null
            }
        </div>
    );
}

export { TooltipComponent };
